import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={18}
    fill="none"
    {...props}
  >
    <g fill="#383838" clipPath="url(#a)">
      <path d="M20 11.572c0-2.84-2.8-5.142-6.25-5.142-3.451 0-6.25 2.302-6.25 5.143 0 2.84 2.799 5.142 6.25 5.142.567 0 1.107-.082 1.631-.2L18.751 18l-1.166-2.395c1.461-.94 2.415-2.39 2.415-4.033Zm-8.125-.32a.952.952 0 0 1-.938-.964.95.95 0 0 1 .938-.964.95.95 0 0 1 .938.964.95.95 0 0 1-.938.964Zm3.75 0a.952.952 0 0 1-.939-.964.95.95 0 0 1 .938-.964.95.95 0 0 1 .939.964.95.95 0 0 1-.938.964Z" />
      <path d="M13.75 5.143c.38 0 .749.032 1.114.078C14.204 2.25 11.16 0 7.5 0 3.358 0 0 2.878 0 6.428c0 2.047 1.123 3.861 2.865 5.037L1.876 13.5l2.694-1.187c.578.21 1.178.385 1.82.465a5.506 5.506 0 0 1-.138-1.208c0-3.545 3.363-6.428 7.5-6.428l-.002.002ZM10 2.893c.518 0 .939.43.939.963a.95.95 0 0 1-.938.964.95.95 0 0 1-.938-.964.95.95 0 0 1 .938-.964ZM5 4.82a.952.952 0 0 1-.939-.964c0-.533.421-.964.939-.964.517 0 .938.431.938.964 0 .533-.421.964-.938.964Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v18H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
